import filterMatchOptions from "./filterMatchOptions";

const FILTER_LABELS = {
  label: "Label",
  color: "Color",
  type: "Type",
  tags: "Tags",
  date: "Date",
  duration: "Duration",
  summary: "Summary",
  narrative: "Narrative"
};

const matchSegmentOptions = [
  {
    label: "Match All",
    value: filterMatchOptions.ALL
  },
  {
    label: "Match Any",
    value: filterMatchOptions.ANY
  },
  {
    label: "Match None",
    value: filterMatchOptions.NONE
  }
];

const matchCriteriaOptions = [
  {
    label: "Match All",
    value: filterMatchOptions.ALL
  },
  {
    label: "Match Any",
    value: filterMatchOptions.ANY
  }
];

export { FILTER_LABELS, matchCriteriaOptions, matchSegmentOptions };
